import { computed, ref } from '@vue/composition-api';

const csvExportDialog = ref(false);
const editOpen = ref(false);
export { csvExportDialog,
         editOpen,
};
